export default __webpack_public_path__ + "static/media/smart-home-nuemorphism-circle.c4d13858.webp";